import React from 'react';
import {FaIcon} from "../FaIcon";
import {getChannelVisual} from "../agency/CustomMetricEditor/metric_search";

// Nombre corto por grupo de canal. El color y el ícono vienen del SSOT CHANNEL_VISUAL
// (metric_search.js) — acá sólo agregamos el label visible.
const GROUP_LABEL = {
    GOOGLE: 'Google',
    META: 'Meta',
    TIKTOK: 'TikTok',
    LINKEDIN: 'LinkedIn',
    DV360: 'DV360',
    GA4: 'GA4',
    GSC: 'Search Console',
    ECOMMERCE: 'Ecommerce',
    KLAVIYO: 'Klaviyo',
};

// Badge de canal con logo + color de marca. Reemplaza el chip marrón de "requiere integración".
// Si el grupo no tiene visual asociado (ej. PAID_MEDIA genérico / BU), no renderiza nada.
// `compact`: sólo el ícono (panel derecho / espacios chicos).
export function ChannelBadge({group, compact = false}) {
    const visual = getChannelVisual(group);
    if (!visual) return null;
    const label = GROUP_LABEL[group] || group;
    return (
        <span className={`ccm-chan${compact ? ' -compact' : ''}`} title={label}>
            <FaIcon
                prefix={visual.prefix}
                iconName={visual.iconName}
                className="ccm-chan__icon"
                style={{color: visual.color}}
            />
            {!compact && <span className="ccm-chan__label">{label}</span>}
        </span>
    );
}

export default ChannelBadge;
